import { Button, ControlGroup, Tag } from "@blueprintjs/core";
import React from "react";
import ClickToCopy from "./ClickToCopy";
import LastUpdated from "./LastUpdated";

class IMSInfoDelete extends React.Component {
  state = {
    deleteClicked: false,
    isOpen: false,
  };

  renderCG = () => {
    return (
      <ControlGroup vertical={this.props.isVertical}>
        {this.props.isVertical ? (
          <Button
            icon="double-chevron-up"
            onClick={() => this.setState({ isOpen: false })}
          />
        ) : null}

        {this.props.changed ? (
          <Tag intent="warning" icon="warning-sign" large>
            Unsaved Changes
          </Tag>
        ) : null}
        {this.props.data.isShell ? (
          <Tag intent="warning" icon="circle" large>
            Shell Entity
          </Tag>
        ) : null}

        <ClickToCopy text={this.props.data._id} minimal={true} />
        <LastUpdated data={this.props.data} minimal={true} />
        {this.props.noDelete ? null : (
          <>
            {this.state.deleteClicked ? (
              <ControlGroup>
                <Button
                  disabled={this.props.disabled}
                  intent="danger"
                  text="Confirm Deletion"
                  onClick={() => this.props.onDelete()}
                />
                <Button
                  disabled={this.props.disabled}
                  outlined
                  intent="success"
                  text="Cancel"
                  onClick={() => this.setState({ deleteClicked: false })}
                />
              </ControlGroup>
            ) : (
              <Button
                disabled={this.props.disabled}
                icon="trash"
                intent="danger"
                outlined
                onClick={() => {
                  this.setState({ deleteClicked: true });
                }}
              />
            )}
          </>
        )}
      </ControlGroup>
    );
  };
  render() {
    return (
      <>
        {this.props.isVertical ? (
          this.state.isOpen ? (
            <>{this.renderCG()}</>
          ) : (
            <Button
              icon="info-sign"
              onClick={() => this.setState({ isOpen: true })}
            />
          )
        ) : (
          <>{this.renderCG()}</>
        )}
      </>
    );
  }
}

export default IMSInfoDelete;
